import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-images-list',
  templateUrl: './images-list.component.html',
  styleUrls: ['./images-list.component.scss']
})
export class ImagesListComponent implements OnInit {
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() toggle ;
  @Output() closeHotSpotBoxEmit = new EventEmitter();
  @Output() changeMediaEmit = new EventEmitter();
  @Output() closeMenuEmit = new EventEmitter();
  @Output() emptyMediaEmit = new EventEmitter();
  @Output() deleteMediaEmit = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  changeMedia(media) {
    this.changeMediaEmit.emit(media);
  }

  closeMenu() {
    this.closeMenuEmit.emit(true);
  }


  editMediaEmit(response) {
    if ($('#editMediaTitleModal')) {
      $('#editMediaTitleModal').modal('hide');
    }
    this.selectedMedia.title = response.media_name;
    this.changeMediaEmit.emit(this.selectedMedia);
  }

  modalCloseEmit(hotspot) {
    if ($('#editMediaTitleModal')) {
      $('#editMediaTitleModal').modal('hide');
    }
  }

  deleteModalCloseEmit(response) {
    if ($('#deleteTitleModal')) {
      $('#deleteTitleModal').modal('hide');
    }
    if (response) {
      this.mediaData = _.filter(this.mediaData, (media) => {
        return media.uuid !== response.uuid;
      });
      this.deleteMediaEmit.emit(response);
      if (this.mediaData.length > 0) {
        this.selectedMedia = this.mediaData[0];
        this.changeMediaEmit.emit(this.selectedMedia);
      } else {
        this.emptyMediaEmit.emit(true);
      }
    }
  }


}
